import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import axios from 'axios';
import { API_BASE_URL, API_KEY } from '../../../../constants';
import { useParams } from 'react-router-dom';
import axiosInstance from '../../../../axios';

function FeedbackForm({ isOpen, onClose, onInvite, onCancel }) {
  const { userId } = useParams();
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const userData = JSON.parse(localStorage.getItem('userData')) || {}
  const member_id=userData.user_profile?.member_id || ''
  // Set the default country code to +91
  const defaultCountryCode = '+91';

  const [feedback_details, setFeedback] = useState({
    subject:'',
    content: '',
    user:member_id
  });

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axiosInstance.get(`${API_BASE_URL}countries/`);

        // Map the API response to an array of objects with value and label properties
        const countryOptions = response.data.data.map(country => ({
          value: country.dial_code,
          label: country.dial_code,
        }));

        setCountries(countryOptions);
      } catch (error) {
        console.error('Error fetching country codes:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCountries();
  }, []);

  const handlecontentChange = (e) => {
    const newContent=e.target.value;
    setFeedback((prevUser) => ({
      ...prevUser,
      content: newContent,
    }));
  };

  const handlesubjectChange = (e) => {
    const newValue = e.target.value;
    setFeedback((prevUser) => ({
      ...prevUser,
      subject: newValue,
    }));
  };

  const handleFeedbackClick = async () => {
    const data = {
      author: member_id,
      subject: feedback_details.subject,
      content: feedback_details.content
    };
    try {
      const response = await axiosInstance.post(
        `${API_BASE_URL}member-feedbacks/`,
        data,
        {
          headers: {
            'X-Api-Key': API_KEY,
            'Content-Type': 'application/json',
          },
        }
      );

      // Handle response as needed
    } catch (error) {
      console.error('Error inviting friends:', error);
    } finally {
      setLoading(false);
    }

    // Handle other logic after inviting
    //onInvite(feedback_details);
    setFeedback(feedback_details.content='',feedback_details.subject='');
    onClose();
  };

  const handleCancelClick = () => {
    onCancel();
    onClose();
  };

  return isOpen ? (
    <div className="popup-overlay">
      <div className="popup">
        {loading ? (
          <p>Loading countries...</p>
        ) : (
          <>
            <span className="close-button" onClick={onClose}>
              X
            </span>
            <h2>Feedback</h2>

            <div className="input-container" style={{ display: 'flex', alignItems: 'center', paddingTop: '10px' }}>
              {/* <label htmlFor="subject" style={{ marginRight: '10px', width: '200px' }}>
                Subject
              </label> */}
              <input
                type="text"
                id="subject"
                value={feedback_details.subject}
                onChange={handlesubjectChange}
                placeholder="Subject"
              />
            </div>
            <div className="input-container" style={{ display: 'flex', alignItems: 'center', paddingTop: '10px' }}>
              {/* <label htmlFor="content" style={{ marginRight: '10px', width: '200px' }}>
                Content
              </label> */}
              <textarea 
                cols="100"
                rows="10"
                id="content"
                value={feedback_details.content}
                onChange={handlecontentChange}
                placeholder="Your thoughts.."
              />
            </div>

            <div className="button-container">
              <button onClick={handleFeedbackClick}>Proceed</button>
              <button onClick={handleCancelClick}>Cancel</button>
            </div>
          </>
        )}
      </div>
    </div>
  ) : null;
}

export default FeedbackForm;
